
export default {
  name: 'CfSelect',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    mode: {
      type: String,
      default: 'single',
    },
    height: {
      type: String,
      default: '100%',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    searchTitle: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: String,
      default: '',
    },
    noData: {
      type: String,
      default: '',
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      list: [],
      searchValue: '',
    }
  },
  computed: {
    selected: {
      get() {
        return this.modelValue
      },
      set(v) {
        return this.$emit('update:modelValue', v)
      },
    },
    getList: {
      get() {
        return this.list
      },
      set(v) {
        this.list = v
      },
    },
    selectedLabel() {
      return this.list.find((it) => it.value === this.selected)?.label
    },
  },
  watch: {
    options: {
      handler(nv) {
        this.list = nv
      },
      immediate: true,
    },
  },
  methods: {
    showActionSheet() {
     if( this.disabled ) {
      return
     }
      this.show = true
    },
    onSearchInput(val) {
      if (val) {
        this.list = this.options.filter(
          (it) => it.label.includes(val) || it.value.includes(val)
        )
      } else {
        this.list = this.options
      }
    },
    onSelectCell(cell) {
      if (!this.hasFooter) {
        this.show = false
      }
      this.onDelOrAddCell(cell || '')
    },
    onDelOrAddCell(cell) {
      if( cell ){
        this.selected = cell.value
      } else {
        this.selected = ''
      }
    },
    onSelected() {
      this.show = false
    },
    onActionClosed() {
      this.searchValue = ''
      this.onSearchInput(this.searchValue)
    },
  },
}
